import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useQuery } from "@tanstack/react-query";

export const getCustomAddressesQueryKey = () => ["custom-addresses"];

export const useCustomAddresses = () => {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery({
    queryKey: getCustomAddressesQueryKey(),
    queryFn: async () => {
      const response = await rpcClient.getAddressCollections({
        types: ["custom"],
      });
      return response.addresses;
    },
  });
};
